export const TooltipStyling = {
  backgroundColor: "#f5f5f9",
  color: "rgba(0, 0, 0, 0.87)",
  width: 420,
  border: "1px solid #dadde9",
};
